import React from 'react'

export default function PdfToPowerpoint(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <g clip-path="url(#a)">
          <g mask="url(#b)">
            <path
              fill="currentColor"
              fill-opacity=".1"
              d="M30.7 6.2 25.4 1c-.3-.3-.7-.5-1.1-.4h-16c-1.1 0-2 .9-2 2v17c.3 0 .7-.1 1-.1 5.1-.1 9.3 4 9.4 9.1 0 .9-.1 1.8-.4 2.7h12.9c1.1 0 2.1-.9 2.1-2v-22c-.1-.4-.3-.8-.6-1.1Z"
              opacity=".1"
            />
            <path
              fill="currentColor"
              d="M31.2 5.8 26 .7c-.5-.4-1.1-.7-1.8-.7H8.6c-1.7 0-3 1.3-3.1 2.9v16.8c.3-.1.7-.1 1-.2V3c0-1.1.9-2 2-2h15.7c.4 0 .8.2 1.1.4l5.2 5.1c.3.3.5.7.5 1.1V29c0 1.1-.9 2-2 2H16.3c-.1.3-.2.7-.3 1h13c1.7 0 3-1.3 3-3V7.6c0-.7-.3-1.3-.8-1.8Z"
            />
            <path
              fill="currentColor"
              d="M7.5 30H4c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Zm0-9C3.4 21 0 24.3 0 28.5S3.3 36 7.5 36s7.5-3.3 7.5-7.5c-.1-4.1-3.4-7.4-7.5-7.5Z"
            />
            <path
              fill="currentColor"
              fill-opacity=".1"
              d="M7.5 30H4c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Zm20.09-12.284H11.705c-.323 0-.565-.209-.565-.487v-4.737c0-.278.242-.487.565-.487H27.63c.323 0 .565.209.565.487v4.702c0 .278-.283.522-.605.522Z"
            />
            <path
              fill="currentColor"
              fill-opacity=".1"
              d="M11.705 17.716c-.323 0-.565-.209-.565-.487l-.015-3.9H9.689c-.322 0-.564.208-.564.487v4.701c0 .279.242.488.564.488h15.885c.323 0 .605-.209.605-.488v-.8l-14.474-.001Z"
            />
            <path
              fill="currentColor"
              d="M27.945 12.493c0-.106-.094-.237-.315-.237H11.705c-.22 0-.315.13-.315.237v4.736c0 .106.094.237.315.237H27.59c.22 0 .356-.164.356-.27v-4.703Zm-18.57 6.025c0 .108.095.238.314.238h15.885c.244 0 .355-.15.355-.238v-.552H11.705c-.425 0-.815-.287-.815-.736l-.014-3.65H9.689c-.22 0-.314.13-.314.237v4.7Zm19.07-1.323c0 .394-.33.69-.697.757l-.16.015-1.16-.001v.552c0 .47-.452.738-.854.738H9.69c-.424 0-.814-.288-.814-.738v-4.701c0-.45.39-.737.814-.737h1.2v-.587c0-.45.391-.737.816-.737H27.63c.425 0 .815.288.815.737v4.702Z"
            />
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M12.25 4.838a1.266 1.266 0 0 0-.59-.122h-.83v1.94h.835c.237 0 .432-.04.585-.122a.811.811 0 0 0 .347-.344c.077-.147.116-.317.116-.508a1.05 1.05 0 0 0-.116-.506.778.778 0 0 0-.347-.338Z"
              clip-rule="evenodd"
            />
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M14.745 2.88c.397 0 .736.338.736.735v6.01a.748.748 0 0 1-.736.735h-6.01A.747.747 0 0 1 8 9.625v-6.01c0-.397.338-.735.735-.735h6.01ZM9.6 9.528V3.71h2.296c.44 0 .816.085 1.127.253.31.167.547.399.71.696.165.296.247.636.247 1.023 0 .386-.083.727-.25 1.022-.168.296-.42.537-.724.69-.314.165-.695.248-1.142.248H10.83v1.886H9.6Z"
              clip-rule="evenodd"
            />
          </g>
        </g>
      </svg>
    </div>
  )
}
